export type Tab = 'sites' | 'domains' | 'settings';

export type View =
  | { kind: 'list' }
  | { kind: 'create' }
  | { kind: 'detail'; projectId: string }
  | { kind: 'domains' }
  | { kind: 'settings' };

export function tabFromView(v: View): Tab {
  if (v.kind === 'domains') return 'domains';
  if (v.kind === 'settings') return 'settings';
  return 'sites';
}

export function viewFromTab(t: Tab): View {
  if (t === 'domains') return { kind: 'domains' };
  if (t === 'settings') return { kind: 'settings' };
  return { kind: 'list' };
}
